import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  MenuItem,
  IconButton,
  Menu,
  useMediaQuery,
  useTheme as useMuiTheme
} from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import MenuIcon from "@mui/icons-material/Menu";
import HelpIcon from "@mui/icons-material/Help";
import { useTheme } from "../../context/ThemeContext";

const Header = ({ onOpenInstructions }) => {
  const { themeMode, toggleThemeMode } = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));
  const [anchorEl, setAnchorEl] = useState(null);
  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navItems = [
    { title: "Dashboard", url: "https://www.evidencer.io/" },
    { title: "Artifacts", url: "https://artifacts.freeweb3.com" },
    { title: "Tools", url: "https://hero.evidencer.io/" },
    { title: "Documentation", url: "/documentation.html" },
  ];

  return (
    <AppBar position="static" color="primary">
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {/* Logo Section */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <a
              href="https://hero.evidencer.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://zpl0eg1fzvvynkgt.public.blob.vercel-storage.com/w3le-200w-jWDyOUJ8HoreMXISAEGro21IZhF2hq.png"
                alt="Web3 Legal Engineering"
                style={{ width: "200px", marginRight: "20px", height: "auto" }}
              />
            </a>
          </Box>

          {/* Desktop Navigation */}
          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {navItems.map((item, index) => (
                <Typography key={index} variant="h6" sx={{ mx: 2 }}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: "white", 
                      textDecoration: "none",
                      '&:hover': {
                        textDecoration: "underline"
                      } 
                    }}
                  >
                    {item.title}
                  </a>
                </Typography>
              ))}
              
              {/* Help Button */}
              <IconButton 
                onClick={onOpenInstructions} 
                color="inherit"
                sx={{ ml: 2 }}
                aria-label="Open Instructions"
              >
                <HelpIcon />
              </IconButton>
              
              {/* Theme Toggle */}
              <IconButton 
                onClick={toggleThemeMode} 
                color="inherit"
                sx={{ ml: 2 }}
                aria-label={`Switch to ${themeMode === 'light' ? 'dark' : 'light'} mode`}
              >
                {themeMode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
              </IconButton>
            </Box>
          )}

          {/* Mobile Menu */}
          {isMobile && (
            <Box>
              <IconButton
                color="inherit"
                aria-label="menu"
                edge="end"
                onClick={handleMenuOpen}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                {navItems.map((item, index) => (
                  <MenuItem key={index} onClick={handleMenuClose}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      {item.title}
                    </a>
                  </MenuItem>
                ))}
                <MenuItem onClick={() => {
                  handleMenuClose();
                  onOpenInstructions();
                }}>
                  Instructions
                </MenuItem>
                <MenuItem onClick={toggleThemeMode}>
                  {themeMode === "light" ? "Dark Mode" : "Light Mode"}
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;